import React from 'react';

const NotificationThumbType = () => {
    return (
        <div>

        </div>
    );
};

export default NotificationThumbType;